export default "__VITE_ASSET__SJ9pUUD1__"